import { Container, Text, TextStyle } from 'pixi.js';
import { Container as ContainerComponent } from '@pixi/react';
import { forwardRef, useEffect, useRef } from 'react';
import { A4 } from './Viewport';

export type SignatureProps = {
    name: string | undefined,
    username: string
}

const fontSize = 45;
const textStyle = new TextStyle({ fontSize: fontSize });

const Signature = forwardRef<Container, SignatureProps>(
  ({ name, username }: SignatureProps, ref) => {
    const containerRef = useRef<Container>(new Container());

    useEffect(() => {
      if (ref && containerRef.current) {
        if (typeof ref !== 'function') {
          ref.current = containerRef.current;
        } else {
          ref(containerRef.current);
        }
      }
      const container = containerRef.current;
      container.removeChildren();

      if (name !== undefined) {
        const nameText = new Text(name, textStyle);
        nameText.anchor.set(1);
        nameText.position.set(A4.width, A4.height - fontSize);
        container.addChild(nameText);
      }

      const usernameText = new Text(username, textStyle);
      usernameText.anchor.set(1);
      usernameText.position.set(A4.width, A4.height);
      container.addChild(usernameText);
    // Disable the dependency warning on the following line as the dep is a ref, which
    // isn't involved in rendering.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [name, username]);

    return <ContainerComponent ref={containerRef} />
  }
);

export default Signature;